import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// eslint-disable-next-line no-unused-vars
import ReactGA from 'react-ga4';

// Modifica este código para manejar posibles errores
try {
  // Comprobar si el usuario ya ha dado su consentimiento
  const consent = localStorage.getItem('cookieConsent');
  if (consent === 'accepted') {
    // Solo inicializar si el usuario ha aceptado
    ReactGA.initialize('G-B47NBJBGWX');
  }
} catch (error) {
  console.error('Error al inicializar Google Analytics:', error);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
